import React, { useMemo } from 'react';

import {
  useAddGift,
  useAddVoucher,
  useGiftSingleSelectUpdate,
  useRemoveDiscoveryBox,
  useRemoveGiftPackaging,
  useRemoveVoucher,
  useToggleFundRaising,
  useUpdateItem,
  useUpdateGiftPackaging,
  useRemoveAllEntries,
  useRemoveGift,
  useRemoveNonStandardProduct,
  useToggleEcoPackaging,
  useToggleInsurance,
  updateCompleteState,
  useAddProductToCart,
  useRemoveFreeDeliveryProduct,
  setCopiedProductVoucherCode,
  setRemovedLoyaltyReward,
} from './actions';
import { useValidateCart } from './actions/useValidateCart';
import { CartActions, ICartPageActions } from './model';

export const useActions = (dispatch: React.Dispatch<CartActions>): ICartPageActions => {
  const removeAllItemEntries = useRemoveAllEntries(dispatch);
  const updateItem = useUpdateItem(dispatch);
  const removeNonStandardProduct = useRemoveNonStandardProduct(dispatch);
  const toggleEcoPackaging = useToggleEcoPackaging(dispatch);
  const toggleInsurance = useToggleInsurance(dispatch);
  const addGiftPackaging = useUpdateGiftPackaging(dispatch);
  const removeGiftPackaging = useRemoveGiftPackaging(dispatch);
  const addGift = useAddGift(dispatch);
  const removeGift = useRemoveGift(dispatch);
  const giftSingleSelectUpdate = useGiftSingleSelectUpdate(dispatch);
  const addVoucher = useAddVoucher(dispatch);
  const removeVoucher = useRemoveVoucher(dispatch);
  const toggleFundRaising = useToggleFundRaising(dispatch);
  const removeDiscoveryBox = useRemoveDiscoveryBox(dispatch);
  const validateCart = useValidateCart(dispatch);
  const addProductToCart = useAddProductToCart(dispatch);
  const removeFreeDeliveryProduct = useRemoveFreeDeliveryProduct(dispatch);

  return useMemo(
    () => ({
      updateCompleteState: (data) => updateCompleteState(dispatch, data),
      updateItem,
      removeAllItemEntries,
      removeNonStandardProduct,
      toggleEcoPackaging,
      toggleInsurance,
      addGiftPackaging,
      removeGiftPackaging,
      addGift,
      removeGift,
      giftSingleSelectUpdate,
      addVoucher,
      removeVoucher,
      toggleFundRaising,
      removeDiscoveryBox,
      validateCart,
      addProductToCart,
      removeFreeDeliveryProduct,
      setProductVoucherCode: (data) => setCopiedProductVoucherCode(dispatch, data),
      setRemovedLoyaltyReward: (data) => setRemovedLoyaltyReward(dispatch, data),
    }),
    [
      updateItem,
      removeAllItemEntries,
      removeNonStandardProduct,
      toggleEcoPackaging,
      toggleInsurance,
      addGiftPackaging,
      removeGiftPackaging,
      addGift,
      removeGift,
      giftSingleSelectUpdate,
      addVoucher,
      removeVoucher,
      toggleFundRaising,
      removeDiscoveryBox,
      validateCart,
      addProductToCart,
      removeFreeDeliveryProduct,
      dispatch,
    ],
  );
};
